import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import tic from "./images/icon-success.svg";
import "./App.scss";

export default function SignupForm({ setEmailData }) {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setEmailData(data.Email);
    navigate("/Thanks");
  };

  const list = [
    { text: "Product discovery and building what matters" },
    { text: "Measuring to ensure updates are a success" },
    { text: "And much more!" },
  ];
  console.log(errors);
  return (
    <div className="container">
      <div className="paperLeft">
        <h1 className="title">Stay updated!</h1>
        <p>Join 60,000+ product managers receiving monthly updates on:</p>
        <div className="features">
          {list.map(({ text }, i) => {
            return (
              <div key={i}>
                <img className="tic" alt="tic" src={tic}></img>
                <span>{text}</span>
              </div>
            );
          })}
        </div>
        <div className="email" style={{ marginTop: "50px" }}>
          <span>Email address</span>
          {errors.Email && (
            <span className="errorText">This field is required</span>
          )}

          <input
            className={`emailInput ${errors.Email ? "error" : ""}`}
            placeholder="email@company.com"
            type="text"
            name="email"
            {...register("Email", {
              required: true,
              pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            })}
          ></input>

          <button className="subscribe_btn" onClick={handleSubmit(onSubmit)}>
            Subscribe to monthly newsletter
          </button>
        </div>
      </div>
      <div className="paperRight"></div>
    </div>
  );
}
